<template>
  <span :class="classes">
    <ui-icon :class="$style.icon" :name="icon" />

    <span v-if="!hideValue" :class="$style.text">{{ valueFormatted }}</span>
  </span>
</template>

<script lang="ts" setup>
import { useCssModule, computed } from 'vue'
import { useNumberFormatted } from '@/ui-core/composables/use-number-formatted'
import UiIcon from '../icon/index.vue'
import type { Size } from './consts'

defineOptions({
  name: 'UiCoin'
})

const props = withDefaults(
  defineProps<{
    icon: string
    value?: number
    hideValue?: boolean
    size?: Size
  }>(),
  {
    value: 0,
    hideValue: false,
    size: 'default'
  }
)

const cssModule = useCssModule()

const classes = computed(() => [
  cssModule.coin,
  cssModule['size-' + props.size]
])

const valueFormatted = useNumberFormatted(() => props.value)
</script>

<style lang="scss" module>
@use 'size';

.coin {
  display: inline-flex;
  gap: var-default(--coin-gap);
  align-items: center;

  /* Size */
  @include size.add(s);
  @include size.add(l);
  @include size.add(xl);
}

.icon {
  width: var-default(--coin-icon-height);
  flex-shrink: 0;
  height: var-default(--coin-icon-height);
}

.text {
  @include text-truncate;

  font-family: var-default(--coin-font-family);
  font-size: var-default(--coin-font-size);
  font-weight: var-default(--coin-font-weight);
  line-height: var-default(--coin-line-height);
  letter-spacing: var-default(--coin-letter-spacing);
}
</style>
